import { Comment, TruckComment } from "../models";
import { Post, Get, Delete } from "./apiUtils";

const addCommentAsync = async (comment: Comment): Promise<Comment> => {
  const response = await Post(
    `/api/linehandling/${comment.lineHandlingNo}/comment`,
    JSON.stringify(comment)
  );
  const result = await response.json();
  return result;
};

const deleteCommentAsync = async (
  lineHandlingNo: string,
  commentId: number
): Promise<boolean> => {
  const response = await Delete(
    `/api/linehandling/${lineHandlingNo}/comment?commentId=${commentId}`
  );
  return await response.json();
};

const getCommentsAsync = async (
  lineHandlingNo: string,
  nominationNo: string | undefined = undefined
): Promise<Comment[]> => {
  const response = await Get(
    `/api/linehandling/${lineHandlingNo}/comment${
      nominationNo ? "?nominationNo=" + nominationNo : ""
    }`
  );
  const result = await response.json();
  return result;
};

const getTruckCommentsAsync = async (
  nominationNo: string
): Promise<TruckComment[]> => {
  const response = await Get(`/api/nomination/${nominationNo}/comment`);
  const result = await response.json();
  return result;
};

const addTruckCommentAsync = async (
  comment: TruckComment
): Promise<TruckComment> => {
  const response = await Post(
    `/api/nomination/${comment.nominationNo}/comment`,
    JSON.stringify(comment)
  );
  const result = await response.json();
  return result;
};

const deleteTruckCommentAsync = async (
  nominationNo: string,
  commentId: number
): Promise<TruckComment> => {
  const response = await Delete(
    `/api/nomination/${nominationNo}/comment?commentId=${commentId}`
  );
  const result = await response.json();
  return result;
};

export const commentsApi = {
  addCommentAsync,
  getCommentsAsync,
  deleteCommentAsync,
  getTruckCommentsAsync,
  addTruckCommentAsync,
  deleteTruckCommentAsync,
};
